export default "images/lab.png";